import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { UserRefundType } from './data';
import { getUserRefundPage } from './service';

export type UserRefundState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: UserRefundType[];
};

type UserRefundModelType = {
  namespace: string;
  state: UserRefundState;
  reducers: {
    UserRefundReducer: Reducer<UserRefundState>;
  };
  effects: {
    fetchUserRefundPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const UserRefundModel: UserRefundModelType = {
  namespace: 'userRefund',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    UserRefundReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserRefundState;
    },
  },

  effects: {
    *fetchUserRefundPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserRefundPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserRefundReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.userRefund.current);
      const pageSize = yield select((state: any) => state.userRefund.pageSize);
      yield put({
        type: 'fetchUserRefundPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default UserRefundModel;
